var _defs, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJuhe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1655429975463,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2387,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.6 576l28.8 28.8 0-32C457.6 572.8 451.2 576 441.6 576z",
    "p-id": 2388,
    fill: "#3C91F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8 425.6c41.6-3.2 80-6.4 118.4-6.4l0-19.2-118.4 0L316.8 425.6z",
    "p-id": 2389,
    fill: "#3C91F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M633.6 297.6c0 0 51.2 19.2 112 51.2 16-12.8 28.8-19.2 38.4-32s12.8-22.4 6.4-32c-6.4-12.8-22.4-16-48-19.2l-3.2 0c-96 0-153.6 41.6-156.8 41.6l-19.2-41.6-41.6 0 0 147.2 51.2 0 0 51.2c-16 0-35.2 0-51.2 3.2l0 35.2c38.4-6.4 73.6-12.8 105.6-16l-41.6-64c32-12.8 64-25.6 96-38.4-44.8-32-83.2-41.6-83.2-41.6L633.6 297.6z",
    "p-id": 2390,
    fill: "#3C91F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M787.2 51.2l-544 0c-102.4 0-185.6 83.2-185.6 185.6l0 540.8c0 105.6 83.2 188.8 185.6 188.8l540.8 0c102.4 0 185.6-83.2 185.6-185.6l0-544C972.8 134.4 889.6 51.2 787.2 51.2zM198.4 809.6c-6.4-16-25.6-41.6-25.6-41.6 169.6-28.8 243.2-115.2 243.2-115.2l51.2 54.4C406.4 764.8 243.2 809.6 198.4 809.6zM723.2 460.8c0 0 22.4 54.4 44.8 80-41.6 9.6-108.8 16-179.2 22.4 19.2 25.6 41.6 48 73.6 73.6 76.8-28.8 121.6-92.8 121.6-92.8l92.8 54.4c0 0-70.4 64-147.2 80 41.6 22.4 96 41.6 150.4 54.4 0 0-64 60.8-80 80-115.2-44.8-179.2-102.4-217.6-147.2l0 147.2-112 0 0-211.2c-64 57.6-227.2 105.6-272 105.6-6.4-16-25.6-41.6-25.6-41.6 105.6-16 176-57.6 211.2-86.4-83.2 6.4-144 9.6-144 9.6l-12.8-54.4c48 0 124.8-6.4 208-12.8L435.2 480c-156.8 12.8-240 41.6-240 41.6l-32-80c22.4-3.2 44.8-6.4 70.4-9.6l0-163.2-48 0 0-57.6 390.4 0 0 28.8c38.4-9.6 105.6-25.6 179.2-22.4 57.6 0 96 16 115.2 48 12.8 19.2 12.8 41.6-3.2 70.4-12.8 12.8-25.6 32-48 48 25.6 16 51.2 38.4 73.6 57.6-38.4 32-83.2 67.2-83.2 67.2-19.2-28.8-41.6-54.4-64-73.6-19.2 12.8-41.6 25.6-70.4 41.6C691.2 473.6 707.2 467.2 723.2 460.8z",
    "p-id": 2391,
    fill: "#3C91F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8 336l118.4 0 0 28.8-118.4 0 0-28.8Z",
    "p-id": 2392,
    fill: "#3C91F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8 272l118.4 0 0 25.6-118.4 0 0-25.6Z",
    "p-id": 2393,
    fill: "#3C91F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuhe);
export default __webpack_public_path__ + "static/media/Juhe.82a1331e.svg";
export { ForwardRef as ReactComponent };